import React, { useState } from 'react';
import { Plus, Edit } from 'lucide-react';

const DesignationSetting = () => {
  const [designations, setDesignations] = useState([]);

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Designation Setting</h1>
          <p className="text-sm text-gray-500 mt-1">Manage staff designations</p>
        </div>
        <button className="flex items-center gap-2 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
          <Plus className="h-4 w-4" />
          Add Designation
        </button>
      </div>

      <div className="bg-white rounded-lg shadow overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Designation</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Description</th>
              <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {designations.length === 0 ? (
              <tr><td colSpan="3" className="px-6 py-8 text-center text-gray-500">No designations configured</td></tr>
            ) : (
              designations.map((desig) => (
                <tr key={desig.id}>
                  <td className="px-6 py-4 text-sm font-medium text-gray-900">{desig.name}</td>
                  <td className="px-6 py-4 text-sm text-gray-500">{desig.description}</td>
                  <td className="px-6 py-4 text-right"><button className="text-blue-600 hover:text-blue-900"><Edit className="h-4 w-4" /></button></td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DesignationSetting;